import React from 'react';
import { CheckCircle2, Minus, XCircle } from 'lucide-react';

const Presence = ({ listed }) => {
  if (listed === true) {
    return (
      <span className="inline-flex items-center gap-2">
        <CheckCircle2 size={16} className="rp-status-good" aria-hidden="true" />
        Sí
      </span>
    );
  }
  if (listed === false) {
    return (
      <span className="inline-flex items-center gap-2">
        <XCircle size={16} className="rp-status-critical" aria-hidden="true" />
        No
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-2 text-[var(--lp-muted)]">
      <Minus size={16} aria-hidden="true" />
      No aplica
    </span>
  );
};

const SourcesTable = ({ report }) => (
  <div className="overflow-x-auto">
    <table className="w-full min-w-[30rem] border-collapse text-left">
      <thead>
        <tr className="border-b border-[var(--lp-line)] text-sm text-[var(--lp-muted)]">
          <th scope="col" className="py-3 pr-4 font-normal">Fuente</th>
          <th scope="col" className="px-4 py-3 text-right font-normal">Veces que la IA la citó</th>
          <th scope="col" className="py-3 pl-4 font-normal">¿Apareces?</th>
        </tr>
      </thead>
      <tbody>
        {report.sources.map((source) => (
          <tr key={source.domain} className="rp-keep border-b border-[var(--lp-line)]">
            <td className="lp-mono py-4 pr-4 text-sm">{source.domain}</td>
            <td className="px-4 py-4 text-right font-semibold tabular-nums">{source.citations}</td>
            <td className="py-4 pl-4 text-sm font-semibold">
              <Presence listed={source.clientListed} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SourcesTable;
